import React, { Component } from "react";

import ResumeBox from "../ResumeBox/ResumeBox";

// eslint-disable-next-line react/prefer-stateless-function
class App extends Component {
  render() {
    return <ResumeBox />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js